// extracted by mini-css-extract-plugin
export default {"package":"_2IryOQIZItddcW4gK6Yq-T","packageButtons":"_1Koj9iymB3ewypCjMU_Ul8","packageInfo":"_1nLIB6znRggiS3FnN9MbAK"};